/* Isofin Sticky Footer – single-file asset (injects HTML + CSS + JS)
   Filename: assets/sticky-warenkorb.js
   Scope: globally injected on all pages except cart (controlled in theme.liquid) */

(() => {
  'use strict';

  // --- Prevent double initialization ---
  if (window.__MC_STICKY_LOADED__) return;
  window.__MC_STICKY_LOADED__ = true;

  /* ---------- 1) Mount + Styles ---------- */
  const STYLE = `
html{ min-height:100vh !important; }
body{ min-height:100vh !important; }
#miniCartSticky{
  position:fixed !important; left:0 !important; right:0 !important; bottom:0 !important; z-index:9999 !important;
  font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif !important;
  color:#202325 !important; background:#fff !important; border-top:1px solid rgba(0,0,0,.08) !important;
  box-shadow:0 -8px 24px rgba(0,0,0,.06) !important;
  padding-bottom:env(safe-area-inset-bottom, 0) !important;
  transform: translateZ(0) !important;
  will-change: transform !important;
  backface-visibility: hidden !important;
  -webkit-backface-visibility: hidden !important;
  overflow:visible !important;
}
#miniCartSticky::after{
  content:'' !important; 
  position:absolute !important; 
  left:0 !important; 
  right:0 !important; 
  top:100% !important; 
  height:500px !important; 
  background:#fff !important; 
  pointer-events:none !important;
}
#miniCartSticky::before{
  content:'' !important; 
  position:fixed !important; 
  left:0 !important; 
  right:0 !important; 
  bottom:-50px !important; 
  height:50px !important; 
  background:#fff !important; 
  z-index:9998 !important;
  pointer-events:none !important;
}
#miniCartSticky[data-mc-sticky] *{ box-sizing:border-box !important; }
.mc-wrap{ 
  max-width:min(1200px, 100vw) !important; 
  margin:0 auto !important; 
  padding:10px 25px !important; 
}

/* ======= FILLED ======= */
.mc-wrap.mc-filled{
  display:grid !important;
  grid-template-columns: 2fr 1fr 1.5fr !important;
  grid-template-areas: "left trust right" !important;
  align-items:center !important; gap:18px !important;
}
.mc-left{ grid-area:left !important; display:flex !important; flex-direction:column !important; gap:2px !important; font-size:15px !important; line-height:1.4 !important; }
.mc-headline{ font-size:15px !important; font-weight:700 !important; color:#202325 !important; opacity:.9 !important; }
.mc-items{ font-size:14px !important; opacity:.9 !important; font-weight:500 !important; max-width:65vw !important; overflow-wrap:anywhere !important; }
.mc-items strong{ font-weight:600 !important; }
.mc-items .mobile-short{ display:none !important; }
.mc-items .desktop-full{ display:block !important; }

.mc-trustcol{ grid-area:trust !important; display:flex !important; flex-direction:column !important; gap:4px !important; max-width:420px !important; justify-self:center !important; align-items:flex-start !important; }
.mc-chip{ font-size:12px !important; font-weight:500 !important; color:#1f2326 !important; background:transparent !important; border:none !important; padding:0 !important; line-height:1.4 !important; white-space:nowrap !important; }

.mc-right{ grid-area:right !important; display:flex !important; flex-direction:column !important; align-items:flex-end !important; gap:6px !important; justify-self:end !important; }
.mc-right-top{ display:flex !important; align-items:center !important; gap:16px !important; }
.mc-total-value{ font-size:17px !important; font-weight:700 !important; color:#202325 !important; }
.mc-btn{
  display:inline-flex !important; align-items:center !important; justify-content:center !important;
  padding:12px 24px !important; border-radius:8px !important; font-weight:700 !important; font-size:15px !important;
  background:linear-gradient(180deg,#D6001C 0%,#A80016 100%) !important; color:#fff !important; border:none !important; text-decoration:none !important;
  white-space:nowrap !important; cursor:pointer !important; transition:background .25s ease,transform .25s ease !important;
  appearance:none !important; -webkit-appearance:none !important; text-transform:none !important; letter-spacing:0 !important;
  text-shadow:0 1px 2px rgba(0,0,0,.25) !important;
}
.mc-btn *{ cursor:pointer !important; }
.mc-btn:hover{ 
  background:linear-gradient(180deg,#FF0020 0%,#C4001A 100%) !important; 
  transform:translateY(-2px) !important;
}
.mc-btn-price{ display:none !important; }
.mc-shipping{ font-size:12px !important; color:#111 !important; line-height:1.3 !important; margin-top:4px !important; text-align:right !important; }
.mc-shipping .blue{ color:#007185 !important; font-weight:600 !important; }
.mc-shipping strong{ font-weight:700 !important; }
.mc-shipping .green{ color:#008a00 !important; font-weight:600 !important; }

/* ======= EMPTY ======= */
.mc-wrap.mc-empty{
  display:flex !important; justify-content:space-between !important; align-items:center !important; gap:24px !important;
}
.mc-empty-text{
  font-size:14px !important; line-height:1.4 !important; color:#202325 !important; opacity:0.9 !important;
  font-weight:500 !important; max-width:500px !important;
}
.mc-empty-text strong{ font-weight:700 !important; color:#d12b2b !important; }

/* ======= Premium CTA ======= */
#miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn{
  all: unset !important;
  display:inline-flex !important; align-items:center !important; justify-content:center !important;
  padding:14px 28px !important; border-radius:12px !important;
  background:linear-gradient(180deg,#D6001C 0%,#A80016 100%) !important;
  color:#fff !important; font-size:15px !important; font-weight:700 !important; line-height:1.2 !important;
  letter-spacing:.3px !important; text-align:center !important; cursor:pointer !important; user-select:none !important;
  position:relative !important; overflow:hidden !important; white-space:nowrap !important;
  border:none !important; outline:none !important; isolation:isolate !important; contain:layout paint style !important;
  box-shadow:inset 0 -2px 0 rgba(0,0,0,.15) !important;
  transition:transform .25s cubic-bezier(.4,0,.2,1), box-shadow .25s cubic-bezier(.4,0,.2,1), background .25s cubic-bezier(.4,0,.2,1) !important;
  appearance:none !important; -webkit-appearance:none !important;
  font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif !important;
  animation: mc-gentle-bounce 3s ease-in-out infinite !important;
  text-shadow:0 1px 3px rgba(0,0,0,.30) !important;
}
#miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn::before{
  content:'' !important; position:absolute !important; top:-50% !important; left:-50% !important;
  width:200% !important; height:200% !important;
  background:linear-gradient(45deg,transparent 30%,rgba(255,255,255,.15) 50%,transparent 70%) !important;
  transform:translateX(-100%) translateY(-100%) rotate(45deg) !important;
  animation:mc-shine 3s ease-in-out infinite !important;
}
#miniCartSticky[data-mc-sticky] .mc-btn-content,
#miniCartSticky[data-mc-sticky] .mc-btn-text,
#miniCartSticky[data-mc-sticky] .mc-btn-arrow{ all: unset !important; cursor:pointer !important; }
#miniCartSticky[data-mc-sticky] .mc-btn-content{
  display:flex !important; align-items:center !important; gap:6px !important; position:relative !important; z-index:1 !important;
  color:#fff !important; font:inherit !important; white-space:inherit !important; cursor:pointer !important;
}
#miniCartSticky[data-mc-sticky] .mc-btn-text{ 
  display:inline-block !important; 
  font:inherit !important; 
  color:inherit !important;
  cursor:pointer !important;
}
#miniCartSticky[data-mc-sticky] .mc-btn-arrow{
  display:inline-block !important; 
  margin-left:2px !important; 
  color:#fff !important;
  font-size:inherit !important;
  line-height:1 !important;
  transition:transform .3s ease !important; 
  animation:mc-arrow-pulse 1.5s ease-in-out infinite !important;
  will-change:transform !important;
  cursor:pointer !important;
}
#miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn:hover{
  background:linear-gradient(180deg,#FF0020 0%,#C4001A 100%) !important;
  transform:translateY(-3px) !important;
  box-shadow:inset 0 -2px 0 rgba(0,0,0,.15) !important;
}
#miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn:hover .mc-btn-arrow{
  transform:translateX(6px) !important; 
  animation:none !important;
}
#miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn:active{
  transform:translateY(-1px) !important;
  box-shadow:inset 0 -1px 0 rgba(0,0,0,.15) !important;
  background:linear-gradient(180deg,#D6001C 0%,#A80016 100%) !important;
}
@keyframes mc-shine{0%{transform:translateX(-100%) translateY(-100%) rotate(45deg);}50%{transform:translateX(100%) translateY(100%) rotate(45deg);}100%{transform:translateX(100%) translateY(100%) rotate(45deg);}}
@keyframes mc-arrow-pulse{0%,100%{transform:translateX(0);opacity:.9;}50%{transform:translateX(5px);opacity:1;}}
@keyframes mc-gentle-bounce{0%,100%{transform:translateY(0);}50%{transform:translateY(-3px);}}
@media (max-width: 1100px) { #miniCartSticky[data-mc-sticky] .mc-btn-text { font-size: 14px !important; } }
@media (max-width: 900px)  { #miniCartSticky[data-mc-sticky] .mc-btn-text { font-size: 13px !important; } }

/* Ausklapp-Element */
.mc-items-toggle{ display:none !important; }
.mc-items-arrow{ display:inline-block !important; transition:transform .2s ease !important; font-size:10px !important; }
.mc-items-arrow.open{ transform:rotate(180deg) !important; }
.mc-items-list{ margin-top:2px !important; padding-left:0 !important; list-style:none !important; display:block !important; line-height:1.1 !important; }
.mc-items-list li{ font-size:12px !important; padding:1px 0 !important; opacity:.85 !important; line-height:1.2 !important; }

/* ======= Tablet ======= */
@media (min-width:641px) and (max-width:960px){
  .mc-wrap.mc-filled{
    grid-template-columns: 1fr auto !important;
    grid-template-areas: "left right" !important;
    gap:14px !important; padding:8px 18px !important;
  }
  .mc-wrap.mc-empty{ display:grid !important; grid-template-columns:1fr 1fr !important; gap:20px !important; }
  .mc-trustcol{ display:none !important; }
  .mc-items .mobile-short{ display:none !important; }
  .mc-items .desktop-full{ display:block !important; }
  #miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn{ padding:12px 22px !important; font-size:14px !important; }
  .mc-empty-text{ font-size:13px !important; }
}

/* ======= Mobile ======= */
@media (max-width:640px){
  #miniCartSticky{ 
    padding-bottom:0 !important; 
    position:fixed !important;
    bottom:0 !important;
  }
  .mc-wrap{ 
    padding:8px 16px 4px 16px !important; 
  }
  .mc-wrap.mc-filled{
    grid-template-columns: 1fr !important;
    grid-template-areas: "left" "right" !important;
    gap:4px !important;
  }
  .mc-wrap.mc-empty{ 
    flex-direction:column !important; 
    gap:12px !important; 
    padding:10px 16px 6px 16px !important;
    align-items:center !important;
  }
  .mc-empty-text{ display:none !important; }
  .mc-trustcol{ display:none !important; }
  .mc-items .desktop-full{ display:none !important; }
  .mc-items .mobile-short{ display:inline !important; }
  .mc-headline{ 
    font-size:13px !important; 
    text-align:center !important;
  }
  .mc-items{ font-size:12px !important; }

  .mc-items-toggle{
    display:inline-flex !important; align-items:center !important; gap:4px !important; cursor:pointer !important;
    color:#007185 !important; font-weight:600 !important; font-size:13px !important; user-select:none !important; padding:2px 0 !important;
  }
  .mc-items-toggle:hover{ text-decoration:underline !important; }
  .mc-items-list{
    display:none !important; border-left:2px solid #d12b2b !important; padding-left:10px !important; margin-top:8px !important;
  }
  .mc-items-list.open{ display:block !important; animation:slideDown 0.2s ease !important; }
  .mc-items-list li{ font-size:12px !important; padding:1px 0 !important; margin-bottom:0px !important; line-height:1.2 !important; }

  .mc-right{ 
    align-items:stretch !important; 
    justify-self:stretch !important;
    width: 100% !important;
    gap:5px !important;
  }
  .mc-right-top{ 
    width:100% !important; 
    justify-content:center !important; 
    flex-wrap:wrap !important; 
    gap:10px !important;
  }
  .mc-total-value{ display:none !important; }
  
  /* Mobile Button Fix - mehr wie ein Button aussehen */
  .mc-btn{ 
    padding:12px 24px !important; 
    font-size:14px !important; 
    max-width:100% !important;
    min-width:280px !important;
    margin:0 auto !important;
    display:flex !important; 
    justify-content:center !important; 
    gap:10px !important;
    border-radius:10px !important;
  }
  
  .mc-btn-price{ 
    display:block !important; 
    font-weight:700 !important; 
    font-size:15px !important; 
  }
  .mc-shipping{ 
    text-align:center !important; 
    font-size:11px !important; 
    margin-top:0px !important; 
  }

  /* Mobile Start Button Fix */
  #miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn{
    max-width:100% !important;
    min-width:280px !important;
    margin:0 auto !important;
    padding:13px 24px !important; 
    font-size:13px !important;
    border-radius:11px !important;
  }
  #miniCartSticky[data-mc-sticky] .mc-btn-content{ 
    gap:5px !important; 
    flex-wrap:nowrap !important; 
    justify-content:center !important; 
  }
}
@keyframes slideDown{ from{opacity:0; transform:translateY(-5px);} to{opacity:1; transform:translateY(0);} }

@media (prefers-reduced-motion: reduce) {
  #miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn,
  #miniCartSticky[data-mc-sticky] .mc-btn-arrow,
  #miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn::before,
  .mc-items-list.open {
    animation: none !important;
  }
  #miniCartSticky[data-mc-sticky] button.mc-start-btn.mc-start-btn {
    transition: background .2s ease !important, transform .2s ease !important;
  }
  #miniCartSticky[data-mc-sticky] .mc-btn-arrow {
    transition: transform .2s ease !important;
  }
}
`;

  const HTML_SHELL = `
<div id="miniCartSticky" data-mc-sticky="1" style="display:none">
  <div class="mc-wrap" id="mc-content"><!-- render via JS --></div>
</div>`;

  function ensureMount() {
    if (!document.getElementById('miniCartSticky')) {
      const wrap = document.createElement('div');
      wrap.innerHTML = HTML_SHELL.trim();
      const node = wrap.firstElementChild;
      document.body.appendChild(node);
    }
    if (!document.getElementById('mc-sticky-styles')) {
      const style = document.createElement('style');
      style.id = 'mc-sticky-styles';
      style.textContent = STYLE;
      document.head.appendChild(style);
    }
  }

  /* ---------- 2) Logic ---------- */
  var MC_CONFIG = {
    CALCULATOR_URL: '/pages/kalkulator',
    FREE_SHIPPING_THRESHOLD: 9900,
    SHOW_MAX_ITEMS_DESKTOP: 3,
    POLL_INTERVAL_MS: 2000,
    BURST_MS: 10000,
    BURST_TICK_MS: 600,
    CUTOFF_HOUR_LOCAL: 10,
    EXPERT_CALL_VARIANT_ID: '56015147794805',

    // Scroll-Schwellen für leeren Warenkorb (gefüllt = sofort anzeigen)
    MOBILE_MAX_WIDTH: 640,
    MOBILE_EMPTY_THRESHOLD: 500,   // Für leeren Warenkorb auf Mobile
    DESKTOP_EMPTY_THRESHOLD: 400   // Für leeren Warenkorb auf Desktop
  };

  var MC_STATE = { 
    lastToken:'', 
    burstUntil:0,
    showSticky: false
  };

  function mcNow(){ return Date.now(); }
  function mcTouchBurst(){ MC_STATE.burstUntil = mcNow() + MC_CONFIG.BURST_MS; }
  function mcFormatMoney(c){ return ((c||0)/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'}); }
  function mcTruncate(s,n){ if(!s) return ''; return s.length>n ? (s.slice(0,n-1)+'…') : s; }

  function mcIsMobile() {
    try {
      return window.matchMedia && window.matchMedia(`(max-width:${MC_CONFIG.MOBILE_MAX_WIDTH}px)`).matches;
    } catch(_) {
      return (window.innerWidth || 0) <= MC_CONFIG.MOBILE_MAX_WIDTH;
    }
  }

  // SCROLL-LOGIK: Leerer Warenkorb erst nach Scrollen, gefüllter sofort
  function mcInitScrollChecker() {
    function checkScrollPosition() {
      var content = document.getElementById('mc-content');
      var isEmpty = content ? /\bmc-empty\b/.test(content.className) : true;
      
      // Gefüllter Warenkorb: IMMER sofort anzeigen (Mobile + Desktop)
      if (!isEmpty) {
        MC_STATE.showSticky = true;
        mcApplyVisibility();
        return;
      }
      
      // Leerer Warenkorb: erst nach Scroll anzeigen
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var threshold = mcIsMobile() ? MC_CONFIG.MOBILE_EMPTY_THRESHOLD : MC_CONFIG.DESKTOP_EMPTY_THRESHOLD;
      
      MC_STATE.showSticky = scrollY > threshold;
      mcApplyVisibility();
    }

    // Initial Check nach kurzer Verzögerung
    setTimeout(checkScrollPosition, 100);
    
    // Event Listener
    window.addEventListener('scroll', checkScrollPosition, { passive: true });
    window.addEventListener('resize', checkScrollPosition);
    
    // Auch bei Orientierungsänderung prüfen
    window.addEventListener('orientationchange', function() {
      setTimeout(checkScrollPosition, 100);
    });
  }

  // Sichtbarkeit für Sticky Footer steuern
  function mcApplyVisibility() {
    var root = document.getElementById('miniCartSticky');
    if (!root) return;
    
    root.style.display = MC_STATE.showSticky ? 'block' : 'none';
  }

  // --- Fetch mit hartem No-Cache ---
  async function mcFetchCart(){
    try {
      const url = `/cart.js?_mc_bust=${Date.now()}`;
      const r = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
          'Pragma': 'no-cache'
        }
      });
      return r.ok ? await r.json() : null;
    } catch(e){
      console.error('[mcFetchCart] Fehler:', e);
      return null;
    }
  }

  function mcTotalWithoutExpert(cart){
    const vid = Number(MC_CONFIG.EXPERT_CALL_VARIANT_ID);
    const items = cart.items || [];
    let sum = 0;
    items.forEach(it => {
      const v = typeof it.variant_id === 'string' ? Number(it.variant_id) : it.variant_id;
      if (v !== vid) sum += it.line_price || 0;
    });
    return sum;
  }

  function mcShippingCountdown(total){
    var thr=MC_CONFIG.FREE_SHIPPING_THRESHOLD;
    if(total>=thr){
      return `<strong class="green">Versandkostenfrei</strong>`;
    }else{
      return `Versicherter Versand aus Deutschland`;
    }
  }

  async function mcFixExpertCall(cart){
    const vid = Number(MC_CONFIG.EXPERT_CALL_VARIANT_ID);
    const items = cart.items || [];
    const expert = items.find(it => {
      const v = typeof it.variant_id === 'string' ? Number(it.variant_id) : it.variant_id;
      return v === vid;
    });
    if(!expert || expert.quantity<=1) return;
    try{
      await fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        credentials:'same-origin',
        cache:'no-store',
        body:JSON.stringify({id:expert.key,quantity:1})
      });
      const fresh=await mcFetchCart();
      if(fresh){ Object.assign(cart, fresh); }
    }catch(e){
      console.warn('[mcFixExpertCall] Konnte Menge nicht korrigieren:', e);
    }
  }

  function mcRenderEmpty(){
    var root=document.getElementById('miniCartSticky'); 
    var content=document.getElementById('mc-content'); 
    if(!root||!content) return;
    
    content.className='mc-wrap mc-empty';
    content.innerHTML = `
      <div class="mc-empty-text">
        <strong>Isofin®</strong> – das Original aus deutscher Produktion bietet Ihnen lebenslange Sicherheit & dauerhaft trockene Wände.
      </div>
      <button class="mc-start-btn" type="button" aria-label="Wanddaten eingeben und prüfen">
        <span class="mc-btn-content">
          <span class="mc-btn-text">Sanierung berechnen</span>
          <span class="mc-btn-arrow">→</span>
        </span>
      </button>
    `;

    // Direkte Verlinkung zur Kalkulator-Seite
    const btn = content.querySelector('.mc-start-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        window.location.href = 'https://isofin.de/pages/kalkulator';
      });
    }

    // Trigger Scroll-Check nach Render
    window.dispatchEvent(new Event('scroll'));
  }

  function mcRenderFilled(cart){
    var root=document.getElementById('miniCartSticky'); 
    var content=document.getElementById('mc-content'); 
    if(!root||!content) return;
    
    var items=cart.items||[], total=cart.total_price||0, itemCount=items.length;

    var linesDesktop=[], limit=MC_CONFIG.SHOW_MAX_ITEMS_DESKTOP, overflow=Math.max(0,itemCount-limit);
    items.slice(0,limit).forEach(function(it){
      var qty=it.quantity, title=it.product_title||it.title||'Artikel';
      var variant=(it.variant_title && it.variant_title!=='Default Title')?(' ('+it.variant_title+')'):'';
      linesDesktop.push(`<strong>${qty}×</strong> ${mcTruncate(title,80)}${variant}`);
    });
    if(overflow>0){ linesDesktop.push(`+${overflow} weitere Position${overflow>1?'en':''}`); }

    var linesMobile=[];
    items.forEach(function(it){
      var qty=it.quantity, title=it.product_title||it.title||'Artikel';
      var variant=(it.variant_title && it.variant_title!=='Default Title')?(' ('+it.variant_title+')'):'';
      linesMobile.push(`<strong>${qty}×</strong> ${mcTruncate(title,60)}${variant}`);
    });

    content.className='mc-wrap mc-filled';
    content.innerHTML = `
      <div class="mc-left">
        <div class="mc-headline">
          Ihre lebenslange Sanierungslösung:
          <span class="mc-items-toggle">
            <span>${itemCount} Artikel</span>
            <span class="mc-items-arrow">▼</span>
          </span>
        </div>
        <div class="mc-items">
          <span class="desktop-full">
            <ul class="mc-items-list">
              ${linesDesktop.map(l => '<li>'+l+'</li>').join('')}
            </ul>
          </span>
          <span class="mobile-short">
            <ul class="mc-items-list" id="itemsList">
              ${linesMobile.map(l => '<li>'+l+'</li>').join('')}
            </ul>
          </span>
        </div>
      </div>

      <div class="mc-trustcol" aria-label="Vertrauensnachweise">
        <div class="mc-chip">🏢 TÜV zertifiziertes Unternehmen </div>
        <div class="mc-chip">🧪 MPA geprüfte Wirksamkeit</div>
        <div class="mc-chip">🏭 Seit 1967 – deutsche Qualität</div>
      </div>

      <div class="mc-right">
        <div class="mc-right-top">
          <strong class="mc-total-value">${mcFormatMoney(total)}</strong>
          <a class="mc-btn" href="/pages/kalkulator">
            <span>Zur Übersicht</span>
            <span class="mc-btn-price">${mcFormatMoney(total)}</span>
          </a>
        </div>
        <div class="mc-shipping">${mcShippingCountdown(total)}</div>
      </div>
    `;

    const toggle = content.querySelector('.mc-items-toggle');
    if (toggle) {
      toggle.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        content.querySelectorAll('.mc-items-list').forEach(list => list.classList.toggle('open'));
        content.querySelectorAll('.mc-items-arrow').forEach(arrow => arrow.classList.toggle('open'));
      });
    }

    const checkoutBtn = content.querySelector('.mc-btn');
    if (checkoutBtn) {
      checkoutBtn.setAttribute('href', '/pages/kalkulator');
      checkoutBtn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/pages/kalkulator';
      });
    }

    // Trigger Scroll-Check nach Render (zeigt sofort an weil gefüllt)
    window.dispatchEvent(new Event('scroll'));
  }

  function mcTokenize(cart){
    try{
      const parts = (cart.items || []).map(i => `${i.id}:${i.quantity}`).join('|');
      return `${parts}::${cart.item_count||0}::${cart.total_price||0}`;
    }catch(e){
      return String(Date.now());
    }
  }

  async function mcRenderFromCart(){
    const cart=await mcFetchCart();
    if(!cart) return;

    await mcFixExpertCall(cart);

    const content = document.getElementById('mc-content');
    const uiIsEmpty = content ? /\bmc-empty\b/.test(content.className) : false;

    const token=mcTokenize(cart);
    const changed = token !== MC_STATE.lastToken;

    if(!changed){
      const ship=document.querySelector('#miniCartSticky .mc-shipping');
      if(ship && typeof cart.total_price==='number'){ ship.innerHTML=mcShippingCountdown(cart.total_price); }

      if(uiIsEmpty && (cart.item_count||0)>0){
        mcRenderFilled(cart);
      }
      return;
    }

    MC_STATE.lastToken=token;
    if((cart.item_count||0)>0){ 
      mcRenderFilled(cart); 
    } else { 
      mcRenderEmpty(); 
    }
  }

  function mcAttachCartListeners(){
    ['cart:refresh','cart:updated','ajaxCart:updated','product:added','lineItem:added','lineItem:removed','lineItem:updated'].forEach(function(evt){
      document.addEventListener(evt, function(){ MC_STATE.burstUntil = Date.now() + MC_CONFIG.BURST_MS; mcRenderFromCart(); }, { passive:true });
    });
    document.addEventListener('submit', function(e){
      var f=e.target; try{ if(f && /\/cart\/add/i.test(f.action)){ MC_STATE.burstUntil=Date.now()+MC_CONFIG.BURST_MS; setTimeout(mcRenderFromCart,150); setTimeout(mcRenderFromCart,1200);} }catch(_){}
    }, true);
    document.addEventListener('click', function(e){
      var el=e.target && e.target.closest && e.target.closest('button, a'); if(!el) return;
      var isATC=(el.getAttribute('name')==='add'||/add-to-cart|atc|cart-add/i.test(el.className||'')||/\/cart\/add/.test(el.getAttribute('href')||''));
      if(isATC){ MC_STATE.burstUntil=Date.now()+MC_CONFIG.BURST_MS; setTimeout(mcRenderFromCart,150); setTimeout(mcRenderFromCart,1200); }
    }, true);

    (function(){
      const _fetch=window.fetch;
      window.fetch=function(input, init){
        const url=typeof input==='string'?input:(input&&input.url)||'';
        const p=_fetch(input, init);
        if(/\/cart\/(add|update|change|clear|add\.js|update\.js|change\.js)/.test(url)){ 
          MC_STATE.burstUntil=Date.now()+MC_CONFIG.BURST_MS; 
          p.then(()=>{ setTimeout(mcRenderFromCart,150); setTimeout(mcRenderFromCart,1200); }).catch(()=>{}); 
        }
        return p;
      };
    })();

    (function(){
      const open=XMLHttpRequest.prototype.open, send=XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open=function(method,url){ this._mc_url=url||''; return open.apply(this, arguments); };
      XMLHttpRequest.prototype.send=function(){ 
        this.addEventListener('load',()=>{ 
          if(/\/cart\/(add|update|change|clear)/.test(this._mc_url||'')){ 
            MC_STATE.burstUntil=Date.now()+MC_CONFIG.BURST_MS; 
            setTimeout(mcRenderFromCart,150); 
            setTimeout(mcRenderFromCart,1200);
          } 
        }); 
        return send.apply(this, arguments); 
      };
    })();

    document.addEventListener('visibilitychange', function(){ if(!document.hidden){ MC_STATE.burstUntil=Date.now()+MC_CONFIG.BURST_MS; mcRenderFromCart(); }});
    window.addEventListener('focus', function(){ MC_STATE.burstUntil=Date.now()+MC_CONFIG.BURST_MS; mcRenderFromCart(); });

    setInterval(mcRenderFromCart, MC_CONFIG.POLL_INTERVAL_MS);
    setInterval(function(){ if(Date.now() < MC_STATE.burstUntil){ mcRenderFromCart(); } }, MC_CONFIG.BURST_TICK_MS);
  }

  function ensureStickyAtBodyRoot(){
    function move(){
      var el = document.getElementById('miniCartSticky');
      if (el && el.parentNode !== document.body) document.body.appendChild(el);
    }
    move();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move);
    new MutationObserver(move).observe(document.documentElement, {childList:true, subtree:true});
    var tries = 0, t = setInterval(function(){ move(); if(++tries>30) clearInterval(t); }, 200);
  }

  /* ---------- 3) Boot ---------- */
  function boot(){
    ensureMount();
    ensureStickyAtBodyRoot();
    mcInitScrollChecker();  // Scroll-Logik: leer = nach Scroll, gefüllt = sofort
    mcRenderFromCart();
    mcAttachCartListeners();
    
    // Periodische Sichtbarkeits-Updates
    setInterval(async function(){
      const cart=await mcFetchCart();
      if(cart){
        const ship=document.querySelector('#miniCartSticky .mc-shipping');
        if(ship) ship.innerHTML=mcShippingCountdown(cart.total_price||0);
      }
      mcApplyVisibility();
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();